module.exports = __webpack_public_path__ + "static/media/header-back.37d95b5a.jpg";